export default __webpack_public_path__ + "static/media/BackToSchool_01.1040f615.png";